export default "__VITE_ASSET__d8730ac6__"